import React from 'react'
import PropTypes from 'prop-types'

const IconTotalRecipients = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='69'
      height='61'
      viewBox='0 0 69 61'
      fill='none'
    >
      <path
        d='M50.325 41.0599C42.2416 37.9693 33.3262 34.1654 32.4941 31.669V29.1727C34.279 27.246 35.5825 24.9241 36.298 22.397C37.1547 21.7774 37.7425 20.8541 37.9413 19.8157C38.1401 18.7774 37.935 17.7023 37.3679 16.81C37.249 16.6911 37.249 16.5723 37.1301 16.4534V10.7475C37.1301 4.92278 33.8017 1 26.4317 1C19.0616 1 15.7331 5.04166 15.7331 10.7475V16.4534C15.0527 17.2786 14.7215 18.3371 14.8104 19.403C14.8992 20.469 15.4009 21.458 16.2086 22.1593C16.3275 22.2781 16.4464 22.2781 16.5653 22.397C17.2802 24.9596 18.5826 27.3202 20.3692 29.2916V31.7879C19.6559 34.1654 10.6216 37.9693 2.53833 41.1788C2.19339 41.3008 1.89431 41.5258 1.68166 41.8236C1.46901 42.1213 1.35308 42.4772 1.34961 42.843V49.0244C1.36164 49.4935 1.55337 49.9401 1.88519 50.2719C2.21701 50.6037 2.66358 50.7954 3.13269 50.8075H49.7306C50.1997 50.7954 50.6463 50.6037 50.9781 50.2719C51.3099 49.9401 51.5017 49.4935 51.5137 49.0244V42.7242C51.5102 42.3583 51.3943 42.0024 51.1816 41.7047C50.969 41.407 50.6699 41.1819 50.325 41.0599Z'
        fill='#D8D8D8'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.1507 30.4801C36.7048 32.9253 35.0388 36.0411 34.3637 39.4332C33.6886 42.8253 34.0346 46.3414 35.3579 49.5369C36.6812 52.7324 38.9225 55.4636 41.7982 57.3852C44.6738 59.3069 48.0548 60.3325 51.5135 60.3325C54.9721 60.3325 58.3531 59.3069 61.2288 57.3852C64.1044 55.4636 66.3457 52.7324 67.669 49.5369C68.9923 46.3414 69.3383 42.8253 68.6632 39.4332C67.9881 36.0411 66.3222 32.9253 63.8762 30.4801C62.2605 28.8426 60.3357 27.5424 58.2135 26.655C56.0912 25.7675 53.8138 25.3105 51.5135 25.3105C49.2131 25.3105 46.9357 25.7675 44.8134 26.655C42.6912 27.5424 40.7664 28.8426 39.1507 30.4801Z'
        fill='white'
      />
      <path
        d='M51.3942 55.3959C58.5371 55.3959 64.3275 49.6055 64.3275 42.4626C64.3275 35.3197 58.5371 29.5293 51.3942 29.5293C44.2514 29.5293 38.4609 35.3197 38.4609 42.4626C38.4609 49.6055 44.2514 55.3959 51.3942 55.3959Z'
        fill='#FFD356'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M56.0662 38.3135H46.7109C46.1398 38.3135 45.6768 38.7765 45.6768 39.3477V45.5885C45.6768 46.1596 46.1398 46.6226 46.7109 46.6226H56.0662C56.6374 46.6226 57.1004 46.1596 57.1004 45.5885V39.3477C57.1004 38.7765 56.6374 38.3135 56.0662 38.3135Z'
        fill='white'
        stroke='#595654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M56.7322 38.6709L51.3948 42.986L46.0693 38.6709'
        fill='white'
      />
      <path
        d='M56.7322 38.6709L51.3948 42.986L46.0693 38.6709' stroke='#595654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

IconTotalRecipients.propTypes = {
  className: PropTypes.string
}

export default IconTotalRecipients
